<template>
  <v-row class="mx-0 align-center">
    <v-col
      cols="4"
      class="pa-0"
    >
      <span class="font-weight-medium">SOCSO Number</span>
    </v-col>
    <v-col
      cols="1"
      class="pa-0"
    >
      <span class="font-weight-medium">:</span>
    </v-col>
    <v-col
      cols="7"
      class="pa-0 d-flex align-center"
    >
      <v-progress-circular
        v-if="loading"
        indeterminate
        size="20"
        width="3"
        color="primary"
        class="ml-3"
      />
      <span
        v-else
        class="pl-3"
      >
        {{ (socsoDetail||{}).socso_number ||'N/A' }}
      </span>
      <employee-profile-payroll-socso-detail-dialog-edit
        v-if="$hasPermissionTo(['update employee payroll']) && !isResigned && !loading"
        :socso-detail="socsoDetail"
        :employee-uid="employeeUid"
        @updated="loadEmployeeSocso"
      />
    </v-col>
  </v-row>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollSocsoDetailDialogEdit: () => import('@/components/hris/employee/profile/payroll/socso-detail/DialogEdit'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
    },
    data () {
      return {
        loading: false,
        socsoDetail: {},
      }
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (newVal, oldVal) {
          if (!_.isEmpty(newVal)) {
            this.loadEmployeeSocso()
          }
        },
      },
    },
  
    methods: {
      loadEmployeeSocso () {
        this.loading = true

        this.$api.employeePayrollSocso().list(this.employeeUid)
          .then(res => {
            this.socsoDetail = res.data

            this.loading = false
          })
      },
    },
  }
</script>
